module.exports = __webpack_public_path__ + "img/59.bd9e8d48.jpg";